import {useEffect} from "react";
import {CheckIcon, ThinCloseIcon, ThinDiamondIcon} from "../../components/icons/material-icons";
import '../../static/css/pages/purchase/purchase.css';

export const PurchaseToolModal = (props: { active: boolean, closeHandler: any, title: string, options: string[] }) => {
    useEffect(() => {
        const isActive = props.active;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal web-modal-big" + (props.active ? ' active' : '')}>
                <div className="web-modal-header">
                    <div><b>امکان خریداری نشده است</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="purchase-modal-top">
                        <i><ThinDiamondIcon/></i>
                        <b>{props.title}</b>
                        <span>برای تهیه این امکان با پشتیبانی تماس بگیرید.</span>
                    </div>
                    <div className="purchase-modal-options">
                        <b>برخی از امکانات این بخش:</b>
                        {
                            props.options.map((d,i)=>
                                <div key={"J93Dj_38Ssj8djn"+i}>
                                    <CheckIcon/>
                                    <span>{d}</span>
                                </div>
                            )
                        }
                    </div>
                </div>
            </div>
        </>
    );
};